import { LineItem } from '@medusajs/medusa'
import {
  PricedProduct,
  PricedVariant
} from '@medusajs/medusa/dist/types/pricing'
import { FeesBibOrOther } from '@prisma/client'
import { RaceId } from 'domain/models/ValueObject/EntityIds'
import { RACE_ID } from 'store/constants'
import {
  DiscountRuleType,
  MedusaDiscountWithVariantIds,
  PeyceCartItem,
  PeyceDiscount,
  PeyceProduct,
  PeyceVariant
} from 'store/types'

export const medusaVariantModelizer = (
  variant: PricedVariant & {
    inventory?: {
      reserved_quantity: number
      stocked_quantity: number
      id: string
    } | null
  }
): PeyceVariant => {
  const {
    id,
    created_at,
    updated_at,
    title,
    prices,
    product,
    inventory,
    inventory_quantity,
    manage_inventory,
    inventory_items
  } = variant
  // if (!isNonEmptyArray(prices))
  //   throw new Error('Prices array length should equal at least to 1')
  return {
    id: id as string,
    createdAt: created_at,
    updatedAt: updated_at,
    title: title,
    price: prices[0]?.amount ?? 0,
    product: { id: product?.id as string },
    quantity: inventory_quantity,
    manage_inventory,
    inventoryItemId: inventory_items?.[0]?.inventory_item_id,
    inventory: inventory
      ? {
          reserved: inventory.reserved_quantity,
          stockedQuantity: inventory.stocked_quantity,
          id: inventory.id
        }
      : null
  }
}

export const medusaProductAndVariantsModelizer = (
  product: PricedProduct
): PeyceProduct => {
  const { id, created_at, updated_at, title, variants } = product
  return {
    id: id as string,
    createdAt: created_at,
    updatedAt: updated_at,
    title,
    variants: variants?.map(medusaVariantModelizer)
  }
}

export const _medusaCartItemModelizer = (cartItem: LineItem): PeyceCartItem => {
  const {
    id,
    created_at,
    updated_at,
    metadata,
    variant,
    unit_price,
    adjustments,
    quantity
  } = cartItem
  return {
    id,
    createdAt: created_at,
    updatedAt: updated_at,
    metadata,
    quantity,
    variant: variant?.id
      ? {
          id: variant.id,
          title: variant.title,
          isBib: variant.metadata?.type === FeesBibOrOther.BIB,
          raceId: variant.metadata?.[RACE_ID] as RaceId | undefined,
          product: {
            externalId: variant.product?.external_id,
            title: variant.product?.title,
            isCancellationInsurance:
              variant.product?.handle === 'assur-connect-cancellation'
          }
        }
      : null,
    price: unit_price,
    adjustments
  }
}

export const medusaDiscountModelizer = (
  discount: MedusaDiscountWithVariantIds
): PeyceDiscount => {
  return {
    id: discount.id,
    code: discount.code,
    isPromotion: discount.metadata?.rule === undefined,
    isDisabled: discount.is_disabled,
    usageCount: discount.usage_count,
    startsAt: new Date(discount.starts_at),
    endsAt: discount.ends_at ? new Date(discount.ends_at) : null,
    usageLimit:
      discount.usage_limit === undefined ? null : discount.usage_limit!,
    metadata: discount.metadata,
    rule: {
      type: discount.rule.type as DiscountRuleType,
      value: discount.rule.value,
      variantIds: discount.rule.variantIds
    }
  }
}
